﻿export class yesNoSelect implements ng.IDirective {
    public restrict = 'E';
    public replace = true;
    public template = '<select ng-model="bindTo" ng-options="option.value as option.name for option in values"></select>';
    // note: I really wanted to make the binding attribute ngModel, But I could never get that to really work
    // there are a lot of examples online that seemed to make it work, but it throws if you use it in combination with another directive, like ghiscode validations.
    // so to future dev, if you try to change bindTo to "ngModel" (or if you try to alias it, 'cause yah, I tried that), make sure to test it in combination with the validation library. -jsm
    public scope = {
        bindTo: '='
    };

    public link = (scope: any) => {
        scope.values = [
            { name: 'Yes', value: true },
            { name: 'No', value: false }
        ];
    };

    public static factory(): ng.IDirectiveFactory {
        const directive: ng.IDirectiveFactory = () => new yesNoSelect();
        return directive;
    }
}